import _ from "lodash";

let store;
export function validateAllStepsTill({_store, maxStep}) {
    maxStep = parseInt(maxStep);
    store = _store;
    store.errors = {};

    for (const [key, step] of Object.entries(store.steps)) {
        if (key >= maxStep) return;
        stepValid({_store:store, step:key});
    }
}

export function stepValid({_store, step}) {
    step = parseInt(step)+1;
    store = _store;

    switch (step) {
        case 4:
            skuValid();
            break;
        case 6:
            detailFormValid();
            break;
    }

    return _.isEmpty(store.errors);
}

function skuValid () {
    let rules = {
        sku: ['required'],
    }

    store.errors = {
        ...store.errors,
        ...validateData(store.data, rules),
    };

    store.steps[3].validated = _.isEmpty(store.errors);
}

function detailFormValid() {
    let rules = {
        first_name: ['required'],
        last_name: ['required'],
        phone: ['required'],
        email: ['email', 'required'],
        country: ['required'],
        city: ['required'],
        order_quantity: ['required'],
    }

    store.errors = {
        ...store.errors,
        ...validateData(store.data, rules),
    };

    store.steps[5].validated = _.isEmpty(store.errors);
}

function isValidEmail(email) {
    // Use a regular expression to validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function validateData(data, rules) {
    let errors = {};

    for (let field in rules) {
        for (let rule of rules[field]) {
            let translatedField = $trans(`storefront::flexible_packaging.${field}`);
            if (rule === 'required' && (!data[field] || data[field] === '')) {
                errors[field] = $trans('storefront::flexible_packaging.field_invalid_required', {field: translatedField});
            }
            if (rule === 'email' && data[field] !== '' &&!isValidEmail(data[field])) {
                errors[field] = $trans('storefront::flexible_packaging.field_invalid_email');
            }
        }
    }

    return errors;
}
